import fetch,{postFrom} from '../utils/fetch';


export function newPhonechangevcode(params) {
  return fetch({
    method: 'GET',
    url: '/user/newPhone/change/vcode',
    params
  })
}

export function oldPhonechangevcode(params) {
  return fetch({
    method: 'GET',
    url: '/user/oldPhone/change/vcode',
    params
  })
}

export function phonechange(params) {
  // return fetch({
  //   method: 'POST',
  //   url: '/user/phone/change',
  //   data:params
  // })
  return postFrom('/user/phone/change',params)
}

export function getUserDetail(params) {
  return fetch({
    method: 'GET',
    url: '/user/getUserDetail',
    params
  })
}

export function forgetvcode(params) {
  return fetch({
    method: 'GET',
    url: '/user/password/forget/vcode',
    params
  })
}

export function forgetchange(params) {
  // return postFrom({
  //   method: 'POST',
  //   url: "/user/password/forget/change",
  //   data:params
  // })
  return postFrom('/user/password/forget/change',params)
}
